export interface AnalysisColorPaletteGq {
  // Project data
  id: number;
  themeJson?: string;
  title: string;
  createdByTeamId?: number;
  accessUserCanEdit: boolean;
}

export const AnalysisColorPaletteGqProps = `
  id
  themeJson
  title
  createdByTeamId
  accessUserCanEdit
`;
